module.exports = __webpack_public_path__ + "fonts/4d5a0422b6c3eb25141f6bf5567ded9a.svg";